import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../../Config";

const InterviewModal = (props) => {
  const [ItemDetails, setItemDetails] = useState();
  const [Type, setType] = useState("");
  const [IsAccept, setIsAccept] = useState(true);

  useEffect(() => {
    if (props.RequestedItem.position) {
      setItemDetails(props.RequestedItem.position);
      setType("job");
    } else if (props.RequestedItem.project) {
      setItemDetails(props.RequestedItem.project);
      setType("project");
    } else {
      setItemDetails(props.RequestedItem.activity);
      setType("activity");
    }

    if (props.Decision === "REJECT" || props.Decision === "CANCEL") {
      setIsAccept(false);
    } else {
      setIsAccept(true);
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortenTitle = (Title) => {
    if (window.innerWidth <= 450) {
      if (Title.length < 24) {
        return Title;
      } else {
        return Title.slice(0, 20) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (Title.length < 30) {
        return Title;
      } else {
        return Title.slice(0, 26) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (Title.length < 40) {
        return Title;
      } else {
        return Title.slice(0, 36) + " ...";
      }
    }
  };
  const handleDisplayPopup = () => {
    if (window.innerWidth <= 450) {
      if (ItemDetails.title.length < 24) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (ItemDetails.title.length < 35) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (ItemDetails.title.length < 45) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    }
  };

  const acceptRecommendation = () => {
    let BaseURL;
    let JPAtype;
    if (Type === "job") {
      BaseURL = Config.PositionServiceURL;
    } else if (Type === "project") {
      BaseURL = Config.ProjectServiceURL;
    } else {
      BaseURL = Config.ActivityServiceURL;
    }
    if (Type === "job") {
      JPAtype = "position";
    } else if (Type === "project") {
      JPAtype = "project";
    } else {
      JPAtype = "activity";
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        BaseURL +
        "/api/" +
        JPAtype +
        "/application/invitation",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        recommendationId: props.RequestedItem.id,
        subStage: "INVITE_ACCEPTED",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.CloseModal();
        props.ClickActivePage();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const acceptMoreLikeThisItem = () => {
    let BaseURL;
    let JPAtype;
    if (Type === "job") {
      BaseURL = Config.PositionServiceURL;
    } else if (Type === "project") {
      BaseURL = Config.ProjectServiceURL;
    } else {
      BaseURL = Config.ActivityServiceURL;
    }
    if (Type === "job") {
      JPAtype = "position";
    } else if (Type === "project") {
      JPAtype = "project";
    } else {
      JPAtype = "activity";
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        BaseURL +
        "/api/" +
        JPAtype +
        "/application/invitation",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        recommendationId: props.RequestedItem.recommendationId,
        subStage: "INVITE_ACCEPTED",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.CloseModal();
        props.ClickActivePage();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const acceptInvite = () => {
    if (props.MoreLikeThisIsActive) {
      acceptMoreLikeThisItem();
    } else {
      acceptRecommendation();
    }
  };
  const rejectRecommendation = () => {
    let BaseURL;
    let JPAtype;
    if (Type === "job") {
      BaseURL = Config.PositionServiceURL;
    } else if (Type === "project") {
      BaseURL = Config.ProjectServiceURL;
    } else {
      BaseURL = Config.ActivityServiceURL;
    }
    if (Type === "job") {
      JPAtype = "position";
    } else if (Type === "project") {
      JPAtype = "project";
    } else {
      JPAtype = "activity";
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        BaseURL +
        "/api/" +
        JPAtype +
        "/application/invitation",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        recommendationId: props.RequestedItem.id,
        subStage: "INVITE_REJECTED",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.CloseModal();
        props.ClickActivePage();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const rejectMoreLikeThisItem = () => {
    let BaseURL;
    let JPAtype;
    if (Type === "job") {
      BaseURL = Config.PositionServiceURL;
    } else if (Type === "project") {
      BaseURL = Config.ProjectServiceURL;
    } else {
      BaseURL = Config.ActivityServiceURL;
    }
    if (Type === "job") {
      JPAtype = "position";
    } else if (Type === "project") {
      JPAtype = "project";
    } else {
      JPAtype = "activity";
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        BaseURL +
        "/api/" +
        JPAtype +
        "/application/invitation",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        recommendationId: props.RequestedItem.recommendationId,
        subStage: "INVITE_REJECTED",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.CloseModal();
        props.ClickActivePage();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const rejectInvite = () => {
    if (props.MoreLikeThisIsActive) {
      rejectMoreLikeThisItem();
    } else {
      rejectRecommendation();
    }
  };
  return (
    <React.Fragment>
      {IsAccept ? (
        <div className="cancel-verification-modal-overlay">
          <div className="outline" onClick={() => props.CloseModal()}></div>
          <div className="verification-modal verify-interview">
            <section className="modal-head">
              {ItemDetails === undefined ? null : (
                <span>
                  <h1>{shortenTitle(ItemDetails.title)}</h1>
                  {handleDisplayPopup()}
                  <p>{ItemDetails.workCity}</p>
                </span>
              )}
              <i onClick={() => props.CloseModal()} className="feather-x"></i>
            </section>
            <section className="modal-body">
              <h1>
                {props.Decision === "PROCEED"
                  ? translateText("proceed_anonymous_application_modal_text")
                  : translateText("accept_anonymous_application_modal_text")}
              </h1>
            </section>
            <section className="modal-actions interview-actions">
              <button onClick={() => props.CloseModal()}>
                {translateText("cancel")}
              </button>
              <button
                className="accept-interview"
                onClick={() => acceptInvite()}
              >
                {props.Decision === "PROCEED"
                  ? translateText("proceed")
                  : translateText("accept_invitiation")}
              </button>
            </section>
          </div>
        </div>
      ) : (
        <div className="cancel-verification-modal-overlay">
          <div className="outline" onClick={() => props.CloseModal()}></div>
          <div className="verification-modal">
            <section className="modal-head">
              {ItemDetails === undefined ? null : (
                <span>
                  <h1>{shortenTitle(ItemDetails.title)}</h1>
                  {handleDisplayPopup()}
                  <p>{ItemDetails.workCity}</p>
                </span>
              )}
              <i onClick={() => props.CloseModal()} className="feather-x"></i>
            </section>
            <section className="modal-body">
              <h1>
                {props.Decision === "CANCEL"
                  ? "The application process will be canceled."
                  : "If you reject the invitation, the application process will be cancelled."}
              </h1>
            </section>
            <section className="modal-actions">
              <button onClick={() => props.CloseModal()}>
                {props.Decision === "CANCEL"
                  ? translateText("discard")
                  : translateText("cancel")}
              </button>
              <button onClick={() => rejectInvite()}>
                {props.Decision === "CANCEL"
                  ? translateText("cancel_application")
                  : translateText("reject_invitation")}
              </button>
            </section>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default InterviewModal;
